var directory = (function() {

    var windowLocation = window.location.href;

    // Get url param

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split("=");

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined
                ? true
                : sParameterName[1];
            }
        }
    };
    // Remove all query params

    function removeAllParam() {
        var afterParams = window.location.href.split("?")[0];
        window.location = afterParams;
    }

    // Remove query param

    function removeParam(key, sourceURL) {
        var rtn = sourceURL.split("?")[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            if (params_arr.length > 0) { rtn = rtn + "?" + params_arr.join("&"); }
        }
        return rtn;
    }
    // Function to update URL param if it exists, or add if it doesn't
    function updateUrlParameter(uri, key, value) {
        // remove the hash part before operating on the uri
        var i = uri.indexOf("#");
        if(getUrlParameter("tag")) {
            uri = removeParam("tag", windowLocation);
        }
        if(getUrlParameter("city")) {
            uri = removeParam("city", windowLocation);
        }
        var hash = i === -1 ? "" : uri.substr(i);
        uri = i === -1 ? uri : uri.substr(0, i);
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf("?") !== -1 ? "&" : "?";

        if (!value) {
            // remove key-value pair if value is empty
            uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), "");
            if (uri.slice(-1) === "?") {
                uri = uri.slice(0, -1);
            }
            // replace first occurrence of & by ? if no ? is present
            if (uri.indexOf("?") === -1) uri = uri.replace(/&/, "?");
        } else if (uri.match(re)) {
            uri = uri.replace(re, "$1" + key + "=" + value + "$2");
        } else {
            uri = uri + separator + key + "=" + value;
        }
        // Remove Current subcategoryParam
        return uri + hash;
    }

    // Activities select
    $("#activities-select").on("change", function() {
        if($(this).val() == "All") {
            removeAllParam();
        } else {
            window.location = updateUrlParameter(windowLocation, "activity", $(this).val());
        }
    })
    var currentActivityParam = getUrlParameter("activity");
    if(currentActivityParam) {
        var selectedOption = $("#activities-select").find("option[value='" + currentActivityParam + "']").text();
        $("#activities-select").find("option[value='" + currentActivityParam + "']").prop("selected", true)
        $("#directoryType").text(selectedOption);
    }


    // Tags select
    $("#tags-select").on("change", function() {
        if($(this).val() == "All") {
            window.location.href = removeParam("tag", window.location.href);
        } else {
            window.location = updateUrlParameter(windowLocation, "tag", $(this).val());
        }
    })
    var currentTagParam = getUrlParameter("tag");
    if(currentTagParam) {
        $("#tags-select").find("option[value='" + currentTagParam.replace("%20", " ") + "']").prop("selected", true)
    }

    // Create Great places drop down
    $(".hidden-cities span").each(function() {
        var location = $(this).data("location");
        var location_slug = $(this).data("location-slug");
        var option = "<option value=" + location_slug + ">" + location + "</option>"
        if($("#great-places-select option[value='" + location_slug + "']").length == 0) {
            $("#great-places-select").append(option);
        }
    })

    // Great places select
    $("#great-places-select").on("change", function() {
        if($(this).val() == "All") {
            window.location.href = removeParam("city", window.location.href);
        } else {
            window.location = updateUrlParameter(windowLocation, "city", $(this).val());
        }
    })
    var currentGreatPlaceParam = getUrlParameter("city");
    if(currentGreatPlaceParam) {
        // setTimeout(function() {
            var selectedGreatPlace = $("#great-places-select").find("option[value='" + currentGreatPlaceParam + "']").text();
            $("#great-places-select").find("option[value='" + currentGreatPlaceParam + "']").prop("selected", true)
            $("#directoryLocation").html("<br />(" + selectedGreatPlace + ")");
            console.log(selectedGreatPlace);
        // }, 3000)
    }

})();
